import Axios from "axios";

const state = {
    cart: null,
    isCartPreviewShow: false
};

const getters = {
    cart: state => state.cart,
    isCartPreviewShow: state => state.isCartPreviewShow
};

const mutations = {
    setCart: (state, data) => state.cart = data,
    setIsCartPreviewShow: (state, data) => state.isCartPreviewShow = data
};

const actions = {
    getCart: async (context, data) => {
        let response = await Axios.post((<any>window).App.routes.StoreCart_GetComputedCart);

        if (response.data.coupon === null) {
            response.data.coupon = {};
        }

        context.commit("setCart", response.data);

        return response;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};